import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import MessagePresenter from 'presenters/MessagePresenter';
import Loader from 'sharedComponents/Loader';
import VideoPlayer from 'sharedComponents/VideoPlayer';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import useScreen from 'hooks/useScreen';

import { useFetchStatus } from 'utils/fetchStatusUtils';

import useStyles from './useStyles';

const DEFAULT_DESKTOP_WIDTH = 350;
const DEFAULT_MOBILE_WIDTH = 201;
const DEFAULT_DESKTOP_HEIGHT = 197;
const DEFAULT_MOBILE_HEIGHT = 112;

const VideoMessage = props => {
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { message } = props;
  const { getSignedUrl } = useFirebaseChat();
  const videoLoadingStatus = MessagePresenter.videoLoadingStatus(message);

  useEffect(() => {
    if (useFetchStatus(videoLoadingStatus).isIdle) {
      const data = MessagePresenter.data(message);
      const chatUid = MessagePresenter.chatUid(message);
      const uid = MessagePresenter.uid(message);
      getSignedUrl(chatUid, uid, { key: `${data.storage}/${data.id}` });
    }
  }, [videoLoadingStatus]);

  if (MessagePresenter.isVideoPrepearing(message)) {
    return (
      <Box
        className={classes.loaderContainer}
        width={isDesktop ? DEFAULT_DESKTOP_WIDTH : DEFAULT_MOBILE_WIDTH}
        height={isDesktop ? DEFAULT_DESKTOP_HEIGHT : DEFAULT_MOBILE_HEIGHT}
      >
        <Loader className={classes.loader} />
      </Box>
    );
  }

  const width = isDesktop ? DEFAULT_DESKTOP_WIDTH : DEFAULT_MOBILE_WIDTH;

  return (
    <div className={classes.root}>
      <VideoPlayer url={MessagePresenter.videoUrl(message)} width={`${width}`} />
    </div>
  );
};

VideoMessage.propTypes = {
  message: MessagePresenter.shape().isRequired,
};

export default VideoMessage;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/VideoMessage/VideoMessage.js